import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-deposit-renewal',
  templateUrl: './deposit-renewal.component.html',
  styleUrls: ['./deposit-renewal.component.css']
})
export class DepositRenewalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/accountmaster/deposit-renewal/deposit-renewal.component.ts